// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  client: 'green-carbon-x',
  production: false,
  stripePublishableKey: 'pk_test_aws6ADuDNEpoj1eRDdrwdtfo',
  stripePricingPageKey: 'prctbl_1M4V5n2B8okBWvxa8T8P5U6Z',
  recaptchaSiteKey: '6Lc4vngtAAAAAMWWAy_RAojnsqnplwk2wgjuAjj_',
  accountingRedirect: 'https://dev-greencarbonx.co2analytics.com/home/setup/connect-suppliers',
  defaultStartDate: new Date('2013-01-02'),
  apis: {
    users: 'https://dev-srvc-users.co2analytics.com/api/v1',
    usersV2: 'https://dev-srvc-users.co2analytics.com/api/v2',
    impacts: 'https://dev-srvc-impacts.co2analytics.com/api/v1',
    impactsV2: 'https://dev-srvc-impacts.co2analytics.com/api/v2',
    ecomm: 'https://dev-srvc-ecomm.co2analytics.com/api/v1'
  },
  logo: 'assets/img/GreenCarbonX07-07-202510_19_57_194.jpg',
  logoClass: 'green-carbon-x-logo',
  logoClass2: 'green-carbon-x-logo',
  bypassCode: '',
  suppressFeature: false,
  requirePaymentOnClaimCompany: true,
  checkoutSuccessUrl: 'https://dev-greencarbonx.co2analytics.com/payment-redirect?session_id={CHECKOUT_SESSION_ID}',
  checkoutFailedUrl: 'https://dev-greencarbonx.co2analytics.com/error',
  paymentPlans: [
    {
      displayName: 'Startup',
      name: 'startupPlanYearly',
      logo: 'assets/spa-insight/img/Seed2.png',
      currency: ''
    },
    {
      displayName: 'Small',
      name: 'smallBusinessPlanYearly',
      logo: 'assets/spa-insight/img/Sprout2.png',
      currency: ''
    },
    {
      displayName: 'Medium',
      name: 'mediumPlanYearly',
      logo: 'assets/spa-insight/img/Shrub2.png',
      currency: ''
    },
    {
      displayName: 'Premium',
      name: 'premiumPlanYearly',
      logo: 'assets/spa-insight/img/tree2.png',
      currency: ''
    }
  ]
};
